// pkg127 — ModuleSendControl (D-126c): the one Download / Email-to-staff
// control every module surface uses — the Client-Submitted Forms panel on
// Client's View and each tab of the Client Modules workspace. Staff picker is
// multi-select across the WHOLE staff roster (all roles — recipients are
// firm-validated server-side, D-126a); sending with nobody checked goes to
// the firm's contact email, which is stated right in the picker so the
// fallback is never a surprise.

import React, { useState } from 'react';

export default function ModuleSendControl({
  staff = [],          // full roster: [{ id, name, role, email }]
  downloadLabel = null, // e.g. 'Download .docx' — omit to hide the download button
  onDownload = null,
  onSend = null,        // async (recipientIds[]) => — omit to hide the email button
  firmContactEmail = '',
  compact = false,      // tighter layout for the workspace bar
}) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  function toggle(userId) {
    setSelected((prev) => prev.includes(userId) ? prev.filter((x) => x !== userId) : [...prev, userId]);
    setStatus(''); setError('');
  }

  async function handleSend() {
    setSending(true); setStatus(''); setError('');
    try {
      await onSend(selected);
      const names = staff.filter((u) => selected.includes(u.id)).map((u) => u.name);
      setStatus(names.length
        ? `Sent to ${names.join(', ')}.`
        : `Sent to ${firmContactEmail || 'the firm contact email'}.`);
      setOpen(false);
      setSelected([]);
    } catch (err) { setError(err.message); }
    finally { setSending(false); }
  }

  return (
    <div style={{ minWidth: 0 }}>
      <div className="btn-row" style={{ gap: 8, margin: 0, flexWrap: 'wrap' }}>
        {downloadLabel && onDownload && (
          <button className="btn btn-sm" onClick={() => { setStatus(''); setError(''); onDownload(); }}>
            {downloadLabel}
          </button>
        )}
        {onSend && (
          <button className="btn btn-sm" onClick={() => { setOpen((v) => !v); setStatus(''); setError(''); }}>
            {open ? 'Close' : 'Email to Staff…'}
          </button>
        )}
      </div>

      {open && onSend && (
        <div style={{
          marginTop: 8, border: '1px solid #ddd', borderRadius: 6,
          background: '#fff', padding: 10, maxWidth: compact ? 420 : '100%',
        }}>
          <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#555', marginBottom: 8 }}>
            Pick one or more recipients. With nobody selected, it goes to the firm contact email{firmContactEmail ? ` (${firmContactEmail})` : ''}.
          </div>
          <div style={{ maxHeight: 180, overflowY: 'auto', border: '1px solid #eee', borderRadius: 4 }}>
            {staff.length === 0 ? (
              <div style={{ padding: 10, fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#888' }}>
                No staff members found. Add them in Staff Management.
              </div>
            ) : staff.map((u, i) => (
              <label key={u.id} style={{
                display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', cursor: 'pointer',
                borderBottom: i < staff.length - 1 ? '1px solid #f2f2f2' : 'none',
                background: i % 2 === 0 ? '#fff' : '#fafafa',
              }}>
                <input type="checkbox" checked={selected.includes(u.id)} onChange={() => toggle(u.id)}
                  style={{ width: 15, height: 15, cursor: 'pointer' }} />
                <span style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, flex: 1, minWidth: 0 }}>
                  {u.name}
                  <span style={{ marginLeft: 6, fontSize: 11, color: '#888', textTransform: 'capitalize' }}>({u.role})</span>
                </span>
                <span style={{ fontFamily: 'Arial, sans-serif', fontSize: 11, color: '#aaa', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 160 }}>{u.email}</span>
              </label>
            ))}
          </div>
          <div className="btn-row" style={{ gap: 8, marginTop: 8, marginBottom: 0 }}>
            <button className="btn btn-sm btn-primary" disabled={sending} onClick={handleSend}>
              {sending ? 'Sending…' : selected.length ? `Send to ${selected.length} recipient${selected.length === 1 ? '' : 's'}` : 'Send to Firm Contact'}
            </button>
          </div>
        </div>
      )}

      {status && <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#1a7a5e', marginTop: 6 }}>{status}</div>}
      {error && <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#B85042', marginTop: 6 }}>{error}</div>}
    </div>
  );
}
